import { AppBar, Box, Toolbar } from "@mui/material";
import classNames from "classnames";

import styles from "./header.module.scss";

type Props = {
  children?: React.ReactNode;
  link?: string;
  className?: string;
};

function Header(props: Readonly<Props>) {
  const { children, link, className = "" } = props;

  return (
    <div className={classNames([styles.header, className])}>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          position="static"
          color="secondary"
          className={classNames([styles.appBar])}
        >
          <Toolbar
            sx={{
              justifyContent: "space-between",
            }}
          >
            {link ? (
              <a href={link} className={styles.link}>
                {children}
              </a>
            ) : (
              children
            )}
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
}

export default Header;
